import type { StatsResponse } from "@cdt/shared";
import { useQuery } from "@tanstack/react-query";

import { fetchStats } from "@/lib/statsApi";

export const DASHBOARD_STATS_QUERY_KEY = ["dashboard", "stats"] as const;

export function useDashboardStats() {
  return useQuery<StatsResponse>({
    queryKey: DASHBOARD_STATS_QUERY_KEY,
    queryFn: fetchStats,
    staleTime: 15_000,
    refetchOnWindowFocus: true,
    refetchInterval: 60_000,
  });
}
